<template>
  <div>
    <modal :class-style="'welcone-pad'" :modal-key="'games_left_modal'" @close="$emit('close')" class="modal--welcomeback">
      <template slot="header">

        <h1>{{ getTranslations.home_modals_games_left_you_are }} {{ userDetails.availableGames }} {{ getTranslations.home_modals_games_left_unlocked_games }} </h1>
        <p>{{ getTranslations.home_modals_games_left_play_them_now }}
        </p>

        <img :src="getTranslations.project_config_modal_img" alt="">

      </template>
      <template slot="body" class="welcone-pad">
        <div class="progress_games_won"><img src="static/images/trophy_mod.svg" alt=""> <span class="color">{{ userDetails.currentLevelGamesWon}}</span> <span>{{ getTranslations.home_modals_games_left_games_won }} </span></div>
        <div class="progress-barv2 modal_bar">
          <div class="bar level" :data-size="gamesWonPercentRatio">
            <span class="perc"></span>
          </div>
        </div>
        <div class="progress_games_level"><img src="static/images/rocket_mod.svg" alt=""> <span class="color">{{  gamesRequired }}</span> <span>{{ getTranslations.home_modals_games_left_games_to_level }} </span></div>

        <p >{{ getTranslations.home_modals_games_left_unplayed_games }}

        </p>
        <p>{{ getTranslations.home_modals_games_left_one_game_to_100 }}</p>

        <div class="new_game_buttons_section ">
          <h2>{{ getTranslations.home_modals_games_left_start_game }}</h2>
          <div class="btn_left"><p>{{ getTranslations.home_modals_games_left_random_game }}</p><a href="#"><img src="static/images/random_icon.svg" alt="" @click.prevent="playRandom()"></a></div>
          <div class="btn_right"><p>{{ getTranslations.home_modals_games_left_against_friend }}</p><a href="#"><img src="static/images/friend_icon.svg" alt="" @click.prevent="playFriend()"></a></div>
        </div>


      </template>
    </modal>
    <search-specific-user v-if="showSearchModal" @close="showSearchModal = false"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import SearchSpecificUser from '@/components/home/modals/users/SearchSpecificOpponent';
import NewGameMixin from '@/common/mixins/home';
import { loading } from '@/common/jQuery';

export default {
  name: 'games-left',
  mixins: [NewGameMixin],
  components: {
    Modal,
    SearchSpecificUser,
  },
  data() {
    return {
      showSearchModal: false,
    };
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  methods: {
    playRandom() {
      this.playGame();
    },
    playFriend() {
      this.showSearchModal = true;
    },
    renderProgressBar() {
      loading();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    gamesRequired() {
      return this.userDetails.currentLevelGamesWon + this.userDetails.gamesToNextLevel;
    },
    gamesWonPercentRatio() {
      if (!this.gamesRequired) return 0;
      return Math.round((this.userDetails.currentLevelGamesWon / this.gamesRequired) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/GamesLeft.vue